// Valuation helpers.
//
// As of the pricing-v2 cutover (INTEGRATION_SPEC WI-5) the engine OWNS the
// valuation ladder: every PricingResultV2 carries `valuation.{rv,gc,olv,flv}`
// already depreciated (per-category calibration is a v2-internal concern). The
// portal reads that ladder — it no longer derives GC/OLV/FLV from a flat
// constant. `acceptedPrice` is stored as GC; the engine's auto-accept value is
// `valuation.gc` taken verbatim.
//
// Only the $5 rounding helper survives here — it snaps user-typed price
// overrides to Greg's pricing granularity.
/** Round a price to the nearest $5 — Greg's pricing granularity. Applied to
 *  user-committed overrides so the UI never persists oddly precise numbers
 *  like $123 or $47. */
export function roundToNearest5(value) {
    return Math.round(value / 5) * 5;
}
